export default __webpack_public_path__ + "static/media/LogoPW.58cb3f90.png";